module.exports = __webpack_public_path__ + "/images/cover-multi-hero.0fcbfc8.webp";